export default {
  Title: 'Caregivers',
  Action: 'Create new caregiver',
  CaregiverStatus: 'Caregiver status: ',
  Clients: 'Clients: ',
  Filter: {
    Status: 'Status',
  },
};
